<template>
    <a-modal
            :width="'55%'"
            v-model="updateTemplateName"
            :title="$t('supervise.editSuperviseRule')"
            :maskClosable="maskClosable"
            @ok="handleOk">

        <div style="padding:20px;">
            <a-card>
                <a-form :form="form" v-if="ruleTemplate">
                    <a-form-item :label="$t('supervise.groupName')" v-bind="formItemLayout">
                        <a-input size="small" :disabled="(roles === 'Org' || roles === 'TopOrg') && ruleTemplate.orgLink.split(',').length > 4" v-model="ruleTemplate.name" v-decorator="['templateName',{ rules: [{ required: true, message: $t('supervise.groupNameRequired') },
                        {validator: hasSpecialChar},
                        {max: 30, message: $t('supervise.nameRule')}
                        ] }]"></a-input>
                    </a-form-item>

                    <a-form-item v-if="(roles === 'Org' || roles === 'TopOrg') && ruleTemplate.orgLink.split(',').length > 4" :label="$t('supervise.groupAliasName')" v-bind="formItemLayout">
                        <a-input size="small" v-model="ruleTemplate.aliasName" v-decorator="['templateAliasName',{ rules: [{ required: true, message: $t('supervise.aliasNameRequired') },
                        {validator: hasSpecialChar},
                        {max: 30, message: $t('supervise.nameRule')}] }]"></a-input>
                    </a-form-item>

                    <a-form-item  :label="$t('supervise.groupDescription')" v-bind="formItemLayout">
                        <a-textarea v-model="ruleTemplate.description" v-decorator="['templateDescription',{ rules: [{ required: true, message: $t('supervise.descriptionRequired') },
                        {max: 200, message: $t('supervise.descriptionRule')}] }]"/>
                    </a-form-item>

                    <a-form-item  :label="$t('supervise.applyChild')" v-bind="formItemLayout">
                        <a-checkbox v-model="applyAll"></a-checkbox>
                    </a-form-item>

                    <a-alert showIcon :message="$t('supervise.applyChildTip')" type="info"></a-alert>
                </a-form>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import {mapGetters} from 'vuex'
    import config from '@/config'
    import {hasSpecialChar} from '../../utils/formFunctions'
    export default {
        name: 'ZUpdateTemplateBasic',
        data() {
            return{
                updateTemplateName: false,
                maskClosable: false,
                form: null,
                ruleTemplate: null,
                applyAll: false,
                formItemLayout: {
                    labelCol: {
                        lg: { span: 24 },
                        xl: { span: 5 },
                        xxl: {span:5}
                    },
                    wrapperCol: {
                        lg: { span: 24 },
                        xl: { span: 13 },
                        xxl: {span:12}
                    }
                }
            }
        },
        computed: {
            ...mapGetters(['roles'])
        },
        methods: {
            hasSpecialChar,
            handleOk(){
                let _this = this
                this.form.validateFieldsAndScroll((err, values) => {
                    if (!err) {
                        let param = {}
                        param.id = _this.ruleTemplate.id
                        param.name = _this.ruleTemplate.name
                        param.aliasName = this.ruleTemplate.aliasName || ''
                        param.description = _this.ruleTemplate.description
                        param.applyAll = _this.applyAll
                        this.$http.put(config.api.entity_group_update_url,param).then((response) => {
                            let groupId = _this.ruleTemplate.id
                            if(response.code == 0){
                                _this.updateTemplateName = false
                                // _this.$message.success('修改成功')
                                this.$notification.success({
                                  message: this.$t('global.commitSuccess')
                                })
                                _this.$emit("updateSuccess",groupId)
                            } else {
                               this.$message.error(response.desc)
                            }
                        })
                    }
                })
            },
            showModel(template){
                // console.log(template)
                this.updateTemplateName = true
                this.form = this.$form.createForm(this)
                this.ruleTemplate = template
                console.log(this.ruleTemplate)
                this.$nextTick().then(() => {
                    this.form.setFieldsValue({
                        templateName: template.name,
                        templateAliasName: template.aliasName,
                        templateDescription: template.description
                    })
                })
            }
        }
    }
</script>